import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[mailIdentityValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MailIdentityValidatorDirective, multi: true }]
})
export class MailIdentityValidatorDirective implements Validator {

  constructor() { }
  validate(control: AbstractControl): ValidationErrors | null {
    const email = control.get('email');
    const reEmail = control.get('reEmail');
    if (email && reEmail) {
      let errors: ValidationErrors | null = reEmail.errors;
      if (email.value != reEmail.value) {
        if (errors)
          errors["mailsNotMatch"] = true;
        else
          reEmail.setErrors({mailsNotMatch: true});
      } else {
        if (errors) {
          delete errors["mailsNotMatch"];
          if (Object.keys(errors).length == 0)
            reEmail.setErrors(null);
        }
      }
    }
    return null;
  }
}
